import PropTypes from 'prop-types'
import {useTranslation} from 'react-i18next'
import {Button, Box, Text} from '@chakra-ui/react'
import {Alert} from '~/react/components'

export const OnboardingIncomplete = ({accountingProviderName}) => {
  const {t} = useTranslation('pointsOnPayments')

  const handleCompleteSetup = () => {
    window.location.href = '/points'
  }

  return (
    <Alert
      status="warning"
      iconAlignment="center"
      message={
        <Box
          display="flex"
          flexDirection={{base: 'column', md: 'row'}}
          justifyContent="space-between"
        >
          <Text textStyle="body-intro" alignSelf="center">
            {t('pointsOnPayments:onboarding.incomplete.title', {
              accountingProvider: accountingProviderName,
            })}
          </Text>
          <Button
            variant="primary"
            colorScheme="black"
            onClick={handleCompleteSetup}
          >
            {t('pointsOnPayments:onboarding.incomplete.callToAction')}
          </Button>
        </Box>
      }
    />
  )
}

OnboardingIncomplete.propTypes = {
  accountingProviderName: PropTypes.string.isRequired,
}

export default OnboardingIncomplete
